import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class TokenService {
  constructor(public http: HttpClient) {}

  private header = new HttpHeaders({
    'Content-Type': 'application/json',
    'x-api-key': environment.apiKey,
  });
  public validateEmail(token:  string): Observable<any> {
    const body = {
      query: `
      mutation {
        validateEmail(token: "${token}") {
          code
        }
      }      
      `,
    };
    return this.http.post(environment.baseUrl, body, { headers: this.header });
  }
}
